<template>
  <div class="recipe_add">
    <br />

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'SignCheck' }">申请处方</el-breadcrumb-item>
      <el-breadcrumb-item>家庭医生签约信息</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <hr />
    <!--
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="家庭医生签约信息" name="first">
        <el-container> 
    -->
    <br />
    <el-main>
      <div class="form-region-header font-30">个人信息</div>
      <el-form ref="form" :model="form" label-width="200px">
        <table>
          <tr>
            <td>
              <el-form-item label="患者姓名">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="患者性别">
                <el-radio v-model="form.sex" label="男">男</el-radio>
                <el-radio v-model="form.sex" label="女">女</el-radio>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="患者年龄">
                <el-input v-model="form.age"></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="患者身份证号(选填)">
                <el-input v-model="form.ctizenID" placeholder="请输入患者身份证号" clearable></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="患者手机号码">
                <el-input v-model="form.phone" disabled></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="特殊人群">
                <el-radio v-model="form.special" label="是">是</el-radio>
                <el-radio v-model="form.special" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.special == '是' ">
                <el-form-item>
                  <el-radio v-model="form.specialdetail" label="备孕">备孕</el-radio>
                  <el-radio v-model="form.specialdetail" label="孕妇">孕妇</el-radio>
                  <el-radio v-model="form.specialdetail" label="产妇">产妇</el-radio>
                  <el-radio v-model="form.specialdetail" label="哺乳期">哺乳期</el-radio>
                </el-form-item>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-main>
    <el-main>
      <div class="form-region-header font-30">病史信息</div>
      <el-form ref="form" :model="form" label-width="200px">
        <table>
          <tr>
            <td>
              <el-form-item label="药物/其他过敏史">
                <el-radio v-model="form.hisAllergy" label="是">是</el-radio>
                <el-radio v-model="form.hisAllergy" label="否">否</el-radio>
                <div v-if="form.hisAllergy == '是' ">
                  <el-form-item>
                    <el-input v-model="form.allergyDesc"></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="是否肝功能不全">
                <el-radio v-model="form.hisLiver" label="是">是</el-radio>
                <el-radio v-model="form.hisLiver" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.hisLiver == '是' ">
                <el-form-item>
                  <el-input v-model="form.liverillDesc"></el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="是否肾功能不全">
                <el-radio v-model="form.hisKidney" label="是">是</el-radio>
                <el-radio v-model="form.hisKidney" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.hisKidney == '是' ">
                <el-form-item>
                  <el-input v-model="form.kidneyillDesc"></el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="是否有高血压历史">
                <el-radio v-model="form.hisHypertension" label="是">是</el-radio>
                <el-radio v-model="form.hisHypertension" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.hisHypertension == '是' ">
                <el-form-item label="高压">
                  <el-input v-model="form.highHypertension">
                    <template slot="append">mmHg</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="低压">
                  <el-input v-model="form.lowHypertension">
                    <template slot="append">mmHg</template>
                  </el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="是否有糖尿病史">
                <el-radio v-model="form.hisDiabete" label="是">是</el-radio>
                <el-radio v-model="form.hisDiabete" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.hisDiabete == '是' ">
                <el-form-item>
                  <el-input v-model="form.diabetesDesc"></el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="是否有心脏病史">
                <el-radio v-model="form.hisHeart" label="是">是</el-radio>
                <el-radio v-model="form.hisHeart" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.hisHeart == '是' ">
                <el-form-item>
                  <el-input v-model="form.heartDiseaseDesc"></el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="是否有其他特殊疾病">
                <el-radio v-model="form.hisOther" label="是">是</el-radio>
                <el-radio v-model="form.hisOther" label="否">否</el-radio>
              </el-form-item>
              <div v-if="form.hisOther == '是' ">
                <el-form-item>
                  <el-input v-model="form.otherDiseaseDesc"></el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-main>
    <el-footer>
      <el-button type="primary" @click="onSubmit('form')">保存信息</el-button>
    </el-footer>
    <!--
        </el-container>
      </el-tab-pane>
    </el-tabs>
    -->
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "SignUpdate",
  data() {
    return {
      activeName: "first",
      RegisterUserAPI: "https://yc.suyizaixian.com:30005/RegisterUser",
      form: {
        name: "",
        phone: "",
        sex: "男",
        age: "",
        ctizenID: "",
        special: "否",
        specialdetail: "备孕",
        hisAllergy: "否",
        allergyDesc: "",
        hisLiver: "否",
        liverillDesc: "",
        hisKidney: "否",
        kidneyillDesc: "",
        hisHypertension: "否",
        highHypertension: "",
        lowHypertension: "",
        hisDiabete: "否",
        diabetesDesc: "",
        hisHeart: "否",
        heartDiseaseDesc: "",
        hisOther: "否",
        otherDiseaseDesc: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        medicine: [
          { required: true, message: "请选择药品名字", trigger: "change" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    gotonext() {
      this.$router.replace("/RecipeAdd2");
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onSubmit(formName) {
      console.log(formName);
      if(this.form.name.trim()==""){
        alert("请填写患者姓名");
      }else if(this.form.age.trim()==""){
        alert("请填写患者年龄");
      }else if (this.form.special == "是" && this.form.sex == "男") {
        alert("患者性别与特殊人群冲突");
      } else if (
        this.form.hisHypertension == "是" &&
        (this.form.highHypertension.trim() == "" ||
          this.form.lowHypertension.trim() == "")
      ) {
        alert("请正确添加血压数值");
      } else {
        this.$confirm("是否确认注册?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //this.axios
            //.get(this.RegisterUserAPI)
            //.then(response => (this.info = response.data))
            //.catch(function(err) {
            //    alert(err);
            //});

            var SpecialGroupType;
            if (this.form.special == "否") {
              SpecialGroupType = 1;
            } else {
              switch (this.form.specialdetail) {
                case "备孕":
                  SpecialGroupType = 2;
                  break;
                case "孕妇":
                  SpecialGroupType = 3;
                  break;
                case "产妇":
                  SpecialGroupType = 4;
                  break;
                case "哺乳期":
                  SpecialGroupType = 5;
                  break;
                default:
                  SpecialGroupType = 2;
                  break;
              }
            }
            var highPressureDesc = "";
            if (this.form.hisHypertension == "是") {
              highPressureDesc =
                "高压" +
                this.form.highHypertension +
                "mmgh,低压" +
                this.form.lowHypertension +
                "mmgh";
            }
            let datas = {
              name: this.form.name,
              phone: this.form.phone + "",
              sex: this.form.sex == "男" ? 1 : 2,
              age: this.form.age,
              ctizenID: this.form.ctizenID + "",
              SpecialGroupType: SpecialGroupType,
              isAllergy: this.form.hisAllergy == "否" ? 0 : 1,
              allergyDesc:
                this.form.hisAllergy == "否" ? "" : this.form.allergyDesc,
              isliverill: this.form.hisLiver == "否" ? 0 : 1,
              liverillDesc:
                this.form.hisLiver == "否" ? "" : this.form.liverillDesc,
              isKidneyill: this.form.hisKidney == "否" ? 0 : 1,
              kidneyillDesc:
                this.form.hisKidney == "否" ? "" : this.form.kidneyillDesc,
              isHighPressure: this.form.hisHypertension == "否" ? 0 : 1,
              highPressureDesc:
                this.form.hisHypertension == "否" ? "" : highPressureDesc,
              isDiabetes: this.form.hisDiabete == "否" ? 0 : 1,
              diabetesDesc:
                this.form.hisDiabete == "否" ? "" : this.form.diabetesDesc,
              isHeartDisease: this.form.hisHeart == "否" ? 0 : 1,
              heartDiseaseDesc:
                this.form.hisHeart == "否" ? "" : this.form.heartDiseaseDesc,
              isOtherDisease: this.form.hisOther == "否" ? 0 : 1,
              otherDiseaseDesc:
                this.form.hisOther == "否" ? "" : this.form.otherDiseaseDesc,
              authToken: sessionStorage.getItem("authToken")
            };
            console.log(datas);
            this.axios
              .post(this.RegisterUserAPI, qs.stringify(datas))
              .then(response => {
                let res = response.data;
                //console.log(res);
                if (res.data.result == "success") {
                  this.$router.replace("/RecipeAdd2");
                } else if (
                  res.data.result == "fail" &&
                  res.data.err.code == "ER_DUP_ENTRY"
                ) {
                  alert("该手机号已注册过，无法再次注册");
                }
              }).catch((e) => { alert(e+"，登录超时，请重新登录");});
            //this axios.get('url',{datas:datas});  or else preflight response
          })
          .catch(() => {
            //this.$message({
            //  type: 'info',  // success
            //  message: '已取消删除'
            // });
          });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      //this.$router.replace("/Login");
    }else{
    var phoneNumber = sessionStorage.getItem("userPhone");
    this.form.phone = phoneNumber;
    //console.log("获取当前用户个人信息");
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
